import './App.css';
import { C洞箫指法表 } from './components/xiao.jsx'

function App() {
  return (
    <div className="App">
      <C洞箫指法表 />
    </div>
  );
}

export default App;
